import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status-tag" }

import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastRecoveryStatusIcon',
  props: {
    isRecovered: { type: Boolean, default: false }
  },
  setup(__props: any) {

const t = i18n.t;

const props = __props;

const computedClass = computed(() => {
  return props.isRecovered ? 'recovery-status--recovered' : 'recovery-status--not-recovered';
});

const displayText = computed(() => {
  return props.isRecovered ? t('内示回収ステータス:回収済') : t('内示回収ステータス:未回収');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["status-tag__container", computedClass.value])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(computedClass.value)
      }, _toDisplayString(displayText.value), 3)
    ], 2)
  ]))
}
}

})